const VARIANTS = {
  GREEN: '#0FD08B',
  WHITE: 'white',
  BLUE: '#478FF2'
}

const HelpIcon = ({
  className = '',
  variant = 'WHITE'
}: {
  className?: string
  variant?: keyof typeof VARIANTS
}) => (
  <svg
    className={className}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_6741_11672)'>
      <path
        d='M10.1164 6.48603L10.1162 6.4862C9.96286 6.73192 9.63587 7.05659 9.07528 7.45664L9.07524 7.45658L9.06844 7.46161C8.60993 7.80066 8.29245 8.07061 8.12199 8.38374C8.03954 8.53521 7.99787 8.68703 7.97699 8.83297H7.33048C7.34802 8.62325 7.3925 8.4576 7.50526 8.26254L7.5056 8.26196C7.62394 8.05662 7.86928 7.7948 8.29291 7.484C8.30102 7.47821 8.30918 7.47238 8.31739 7.46652C8.57 7.28616 8.87216 7.07043 9.10632 6.80864C9.36304 6.52161 9.56306 6.15337 9.56306 5.67563C9.56306 5.20127 9.3456 4.83611 8.99499 4.61465C8.67666 4.41358 8.2873 4.35363 7.93839 4.35363C7.34816 4.35363 6.71779 4.51009 6.05363 4.79835L5.82039 4.33003C6.40012 4.07262 7.07652 3.89155 7.73469 3.84365C8.56984 3.78286 9.29969 3.94026 9.78256 4.33326C10.4606 4.8857 10.484 5.89761 10.1164 6.48603ZM7.66639 12.1663C7.39053 12.1663 7.16639 11.9422 7.16639 11.6663C7.16639 11.3904 7.39053 11.1663 7.66639 11.1663C7.94225 11.1663 8.16639 11.3904 8.16639 11.6663C8.16639 11.9422 7.94225 12.1663 7.66639 12.1663Z'
        stroke={VARIANTS[variant]}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 14.6662C11.6819 14.6662 14.6667 11.6814 14.6667 7.99951C14.6667 4.31761 11.6819 1.33285 8 1.33285C4.3181 1.33285 1.33333 4.31761 1.33333 7.99951C1.33333 11.6814 4.3181 14.6662 8 14.6662ZM8 15.9995C12.4183 15.9995 16 12.4178 16 7.99951C16 3.58123 12.4183 -0.000488281 8 -0.000488281C3.58172 -0.000488281 0 3.58123 0 7.99951C0 12.4178 3.58172 15.9995 8 15.9995Z'
        fill={VARIANTS[variant]}
      />
    </g>
  </svg>
)

export default HelpIcon
